// extracted by mini-css-extract-plugin
export default {"item-label":"FontStyleCp_item-label__rNXO5","cp-box":"FontStyleCp_cp-box__9+52R"};